<template>
  <el-form
    ref="form"
    class="auth-form"
    :model="form"
    :rules="rules"
    :label-position="labelPosition"
    :label-width="labelWidth"
  >
    <el-form-item
      label="客户姓名"
      prop="name"
    >
      <el-input
        v-model="form.name"
        placeholder="请输入"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="手机"
      prop="phone"
    >
      <el-input
        v-model="form.phone"
        placeholder="请输入"
        clearable
      >
      </el-input>
    </el-form-item>
    <el-form-item
      label="授权产品"
      prop="productType"
    >
      <el-select
        style="width: 100%"
        popper-class = "specialSelect"
        placeholder="授权产品"
        v-model="form.productType"
        multiple
      >
        <el-option
          v-for="(item,index) in productList"
          :key="index"
          :label="`${item.productName} (${item.productCode})`"
          :value="item.productCode"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      label="授权类型"
      prop="type"
    >
      <el-select
        style="width: 100%"
        popper-class = "specialSelect"
        @change = "typechange"
        placeholder="授权类型"
        v-model="form.type"
      >
        <el-option
          v-for="(item,index) in authtypes"
          :key="index"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item>
      <div slot="label">
        <i class="star">*</i>
        <span>有效期</span>
      </div>
      <!--
          1.如果是添加弹窗，默认选中当天
          2.如果是编辑弹窗，则显示之前的数据
          -->
      <el-row>
        <el-col :span="11">
          <el-form-item
            prop="startTime"
          >
            <el-date-picker
              style="width: 100%;"
              v-model="form.startTime"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="开始时间"
              :disabled="startdisabled"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <div class="short-thing">至</div>
        </el-col>
        <el-col :span="11">
          <el-form-item
            prop="endTime"
          >
            <el-date-picker
              style="width: 100%;"
              v-model="form.endTime"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="结束时间">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form-item>
    <!--
    关于平台和login的逻辑：
    1.添加弹窗不显示这两个字段和按钮。
    2.当客户验证授权码时会获取这两个信息，并在编辑弹窗显示对应字段，一旦这两个字段有值，就只能限制在对应平台和login使用。点击解除限制后清空并且隐藏这两个字段和按钮。
    3.点击解除后需确认提交才真正解除。
    -->

    <el-form-item
      v-if="isEdit && form.platform && liftFlag"
    >
      <div slot="label">
        <span>平台</span>
      </div>
      <el-row :gutter="10">
        <el-col :span="9">
          <el-form-item
            prop="platform"
          >
            <el-input
              v-model="form.platform"
              disabled
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <div class="short-thing">Login</div>
        </el-col>
        <el-col :span="7">
          <el-form-item
            prop="login"
          >
            <el-input
              v-model="form.login"
              disabled
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-button
            type="text"
            @click="liftHandle"
          >解除限制</el-button>
        </el-col>
      </el-row>
    </el-form-item>
    <el-form-item
      v-if="isEdit && form.bindMac && liftFlag"
      prop="bindMac"
      label="Mac"
    >
      <el-input
        v-model="form.bindMac"
        disabled
      ></el-input>
    </el-form-item>
    <el-form-item
      label="推荐人姓名"
    >
      <el-input
        placeholder="选填"
        v-model="form.recommender"
      ></el-input>
    </el-form-item>
  </el-form>
</template>

<script>
import { isMobile } from "@/utils/validate";
import { init_date } from "@/utils";
let defaultForm = {
  name: '',
  phone: '',
  productType: [],

  startTime: '',
  endTime: '',
  // 平台
  platform: '',
  login: '',
  type:1,
  recommender: '',
};
import formLabalPosition from "@/mixins/formLabalPosition";
export default {
  name: "authForm",
  props: {
    formData: {
      type: Object,
      default(){
        return {
          name: '',
          phone: '',
          productType: [],
          type:1,
          startTime: '',
          endTime: '',
          // 平台
          platform: '',
          login: '',
          bindMac: '',

          recommender: '',
        }
      }
    },
    productList: {
      type: Array,
      default(){
        return [];
      }
    },
    isEdit: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    let validatePhone = (rule, value, callback) => {
      if(!isMobile(+value)){
        callback(new Error('请输入正确的格式'));
      }else {
        callback();
      }
    };
    return {
      labelWidth: '100px',
      form: JSON.parse(JSON.stringify(defaultForm)),
      rules:{
        name: [
          { required: true, message: '请输入', trigger: 'blur' },
          // { validator: validateName, trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        productType: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        type: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        endTime: [
          { required: true, message: '请选择', trigger: 'change' },
        ]
      },
      liftFlag: true, // 清除平台
      authtypes:[
        {value:1,label:"普通码"},
        {value:2,label:"试用码"}
      ]
    }
  },
  watch:{
    formData:{
      handler(newValue){
        if(newValue.id){
          this.assign(newValue);
        }
      },
      deep: true,
    },
  },
  computed: {
    startdisabled() {
      // 添加时不可以修改
      // return !this.isEdit;
      return true;
    }
  },
  mixins: [formLabalPosition],
  created(){
    if(!this.isEdit){
      this.initDate();
    };
  },
  methods: {
    reset(){
      this.form = JSON.parse(JSON.stringify(defaultForm));
      this.initDate();
    },
    selfClear(){
      this.$refs.form.clearValidate();
      this.$refs.form.resetFields();
      this.reset();
    },
    assign(){
      let numArr = this.formData.authorizedProducts.split(',');

      this.form.id = this.formData.id;
      this.form.type = this.formData.type;
      this.form.name = this.formData.userName;
      this.form.phone = this.formData.phone;
      this.form.productType = numArr;
      this.form.startTime = this.formData.beginDate;
      this.form.endTime = this.formData.endDate;
      this.form.platform = this.formData.bindPlatform;
      this.form.login = this.formData.bindLogin;
      this.form.bindMac = this.formData.bindMac; //新加的 todo
      this.form.recommender = this.formData.referrer;
    },
    selfValidate(){
      this.$refs.form.validate((valid) => {
        if(valid){
          this.$emit('submit',this.form);
        }else {
          console.log('no-pass');
        }
      })
    },
    liftHandle(){
      // 解除限制
      this.form.platform = '';
      this.form.login = '';
      this.form.bindMac = '';
      this.liftFlag = false;
    },
    initDate(){

      let dateInfo = init_date();
      // this.endTime = dateInfo.oneMonAgo;
      this.form.startTime = dateInfo.today;
    },
    typechange(val){
      if(val == 2){
         // 示例使用
        if(this.form.startTime&&this.form.startTime !=""){
            this.form.endTime = this.getNextMonthDate(this.form.startTime);
        }
      }
    },
    getNextMonthDate(dateStr) {
        // 解析输入日期
        const [year, month, day] = dateStr.split('-').map(Number);
        const originalDate = new Date(year, month - 1, day); // 月份从0开始

        // 计算下个月的年份和月份
        const nextMonthDate = new Date(originalDate);
        nextMonthDate.setMonth(originalDate.getMonth() + 1);

        // 获取下个月的信息
        const nextYear = nextMonthDate.getFullYear();
        const nextMonth = nextMonthDate.getMonth();

        // 计算下个月的最后一天
        const lastDayOfNextMonth = new Date(nextYear, nextMonth + 1, 0).getDate();

        // 确定正确的日期
        const adjustedDay = Math.min(day, lastDayOfNextMonth);

        // 构造结果日期并格式化
        const resultDate = new Date(nextYear, nextMonth, adjustedDay);
        const formattedDate = [
          resultDate.getFullYear(),
          String(resultDate.getMonth() + 1).padStart(2, '0'),
          String(resultDate.getDate()).padStart(2, '0')
        ].join('-');
        return formattedDate;
      }


    // setOptionWidth(event){
    //   this.$nextTick(()=>{
    //     document.querySelector('.specialSelect').style.maxWidth = event.srcElement.offsetWidth + "px";
    //   })
    // }
  },
}
</script>

<style lang="scss" scoped>
.auth-form {
  .star {
    color: #F56C6C;
    padding-right: 5px;
  }
}
</style>
<style lang="scss">
.auth-form {
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .short-thing {
    text-align: center;
    height: 40px;
    line-height: 40px;
  }
}



// 移动端样式
@media screen and (max-width: 768px){
  .specialSelect{
    .el-select-dropdown__item{
      height: auto;
      max-width: 350px;
      white-space: normal;
    }
  }
}
</style>
